import React from "react";

import { mdiLinkVariant, mdiPlus } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";

import Button from "../../button/Button";

import type { UploadMode } from "./types";

interface SourceMediaPanelHeaderProps {
  open: () => void;
  isLoading?: boolean;
  isEncoding: boolean;
  isUploading: boolean;
  isUploadBlocked: boolean;
  isAudioOnly: boolean;
  isVideoSourceLocked: boolean;
  uploadMode: UploadMode;
  onOpenFromUrl: () => void;
}

export default function SourceMediaPanelHeader({
  open,
  isLoading,
  isEncoding,
  isUploading,
  isUploadBlocked,
  isAudioOnly,
  isVideoSourceLocked,
  uploadMode,
  onOpenFromUrl,
}: SourceMediaPanelHeaderProps): React.JSX.Element {
  const { t } = useTranslation("editor-content");

  const isDisabledFromUrlButton =
    isLoading ||
    isEncoding ||
    isUploading ||
    isUploadBlocked ||
    isAudioOnly ||
    isVideoSourceLocked;

  const isDisabledBrowseFilesButton =
    isLoading ||
    isEncoding ||
    isUploading ||
    isUploadBlocked ||
    uploadMode === "none";

  return (
    <div className="flex items-center gap-1">
      <Button
        isDisabled={isDisabledFromUrlButton}
        onClick={onOpenFromUrl}
        size="xs"
        type="button"
        variant="secondary"
      >
        <Icon path={mdiLinkVariant} size={0.7} />
        {t("fromURL")}
      </Button>
      <Button
        withGlow
        isDisabled={isDisabledBrowseFilesButton}
        onClick={open}
        size="xs"
        type="button"
      >
        <Icon path={mdiPlus} size={0.7} />
        {t("browseFiles")}
      </Button>
    </div>
  );
}
